<template>
  <div class="customer-list">
    <h1>{{ title }}</h1>
    <div>
      <div
        v-for="(item, index) in customerList"
        :key="index"
        class="customer-list_item"
        @click="showDetails(index)"
      >
        <img :src="item.img" loading="lazy" />
        <div>
          <span>{{ item.name1 }}</span>
          <span>{{ item.name2 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabSelectIndex: 0,
      customerList: [],
      title: ""
    }
  },
  created() {
    console.log(this.$route.path, "**********path")
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1
    // this.tabSelectIndex = 1
    this.initData()
  },
  methods: {
    initData() {
      const baseUrl = process.env.VUE_APP_PUBLIC_PATH

      fetch(baseUrl + '/customer/data.json')
        .then(response => response.json())
        .then(data => {
          let { details } = data
          this.customerList = details[this.tabSelectIndex + ""].customers
          this.title = details[this.tabSelectIndex + ""].title
          console.log(details, "*******************88")
        })
        .catch(error => console.error('Error loading JSON:', error));
    },
    showDetails(index) {
      console.log("click showDetail", index)
      // 传递 customerTypeIndex（哪类客户） customerIndex （第几个）
      this.$router.push({ path: "/customerDetail/1", query: { customerTypeIndex: this.tabSelectIndex, customerIndex: index } })
    }
  }
}
</script>
<style lang="scss" scoped>
.customer-list {
  width: 80%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;
    margin-top: 50px;
  }
  .customer-list_item {
    width: 300px;
    height: 400px;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center;
    border: 1px solid gray;
   @media screen and (max-width: 768px) {
      width: 220px;
      height: 340px;
      font-size: 14px;
    }
    &:hover {
      box-shadow: 3px 3px 3px #00a7ec;
      color: #00a7ec;
    }
    > img {
      width: 100%;
      height: 80%;
      object-fit: contain;
    }
    > div {
      height: 20%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-top: 1px solid gray;
    }
  }
}
</style>